<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="page-header filled full-block light">
          <div class="row">
            <div class="col-md-6 deal_page_container">
            	<input class="form-control" v-model="contact.name" 
            		v-if="canEditColumn('contact_name',contact.id)"
                @keydown.enter="$event.target.blur()" 
                v-on:blur="updateContact(contact)"
                v-bind:ref="('contact_name'+contact.id)"
              >
              <div v-else @click="editColumn('contact_name',contact.id)">
              	<h4 class="deal_page_info pointer" v-if="contact.name!=''"><i class="fa fa-home"></i> {{contact.name}}</h4>
              	<h4 class="deal_page_info pointer" v-else><i class="fa fa-home"></i>『聯絡人名稱目前為空</h4>
              </div>

             
            </div>
            <div class="col-md-6">
              <button class="btn btn-danger primary-btn pull-right" @click="showDeleteModal=true"><i class="fa fa-trash"></i> 封存聯絡人</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <div class="widget-wrap">
                  <div class="deal_sidebar block-header clearfix">
                    <div class="pull-left">
                      <p>聯絡人資料</p>
                    </div>
                  </div>
                  <div class="widget-container">
                    <div class="widget-content">
                      <div class="row">
                        <div class="col-md-12 deal_page_sidebar_content text-left">
                        	<input class="form-control" v-model="contact.email" 
						            		v-if="canEditColumn('contact_email',contact.id)"
						                @keydown.enter="$event.target.blur()" 
						                v-on:blur="updateContact(contact)"
						                v-bind:ref="('contact_email'+contact.id)"
						              >
						              <div v-else @click="editColumn('contact_email',contact.id)">
						              	<p class="pointer margin0" v-if="contact.email!=''">Email：{{ contact.email }} <i class="fa fa-pen"></i></p>
						              	<p class="pointer margin0" v-else>Email：空空的 <i class="fa fa-pen"></i></p>
						              </div>

                          <input class="form-control" v-model="contact.phone" 
						            		v-if="canEditColumn('contact_phone',contact.id)"
						                @keydown.enter="$event.target.blur()" 
						                v-on:blur="updateContact(contact)"
						                v-bind:ref="('contact_phone'+contact.id)"
						              >
						              <div v-else @click="editColumn('contact_phone',contact.id)">
						              	<p class="pointer margin0" v-if="contact.phone!=''">電話：{{ contact.phone }} <i class="fa fa-pen"></i></p>
						              	<p class="pointer margin0" v-else>電話：空空的 <i class="fa fa-pen"></i></p>
						              </div>

						              <p class="pointer margin0">建立時間：{{ contact.created_at }}</p>
                          <p class="pointer margin0">最後交易時間：{{ contact.last_deal_at }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="widget-wrap">
                  <div class="deal_sidebar block-header clearfix">
                    <div class="pull-left">
                      <p>客戶公司</p>
                    </div>
                    <div class="pull-right">
                      <a @click="changeOrganizationModal=true"><span class="zmdi zmdi-edit pointer"></span></a>
                    </div>
                  </div>
                  <div class="widget-container">
                    <div class="widget-content">
                      <div class="row">
                        <div class="col-md-12 deal_page_sidebar_content">
                          <p class="pointer" v-if="contact.organization_name==''||contact.organization_name==null" @click="ShowOrganization(contact.organization_token)">
                            無所屬公司
                          </p>
                          <p class="pointer" v-else @click="ShowOrganization(contact.organization_token)">
                            {{contact.organization_name}}
                          </p>
                        </div>
                      </div>
                      <div class="text-center">
                        <button class="btn btn-success btn-new" id="show-modal" @click="OrganizationModal = true" v-if="contact.organization_name==null"><i class="fa fa-building"></i>&nbsp;新增公司</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="widget-wrap">
                  <div class="deal_sidebar block-header clearfix">
                    <div class="pull-left">
                      <p>交易紀錄</p>
                    </div>
                  </div>
                  <div class="widget-container">
                    <div class="widget-content">
                      <div class="text-center" v-if="recent_deals==''">
                        <span>目前尚無交易</span>
                      </div>
                      <div v-else class="row">
                        <div class="col-md-12 deal_page_sidebar_content">
                          <div class="media" v-for="deal in recent_deals" @click="ShowDeal(deal.deal_token)">
                          	<div class="medai-body">
                          		<p class="pointer pr-3">
		                          	{{deal.title}} -  ${{deal.value.toLocaleString()}} 
		                          </p>
                          	</div>
                          	<span v-if="deal.status == 'won'" class="label label-success">已簽約</span>
                          	<span v-if="deal.status == 'lost'" class="label label-danger">已丟失</span>
                          	<span v-if="deal.status == 'open'" class="label label-default">進行中</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <activitiesResource :activities="contact_activities" :activity_categories="activity_categories"></activitiesResource> -->
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-12">
                <ul class="nav nav-tabs nav-center" role="tablist">
                  <li role="presentation" class="active"><a href="#new_note" aria-controls="new_note" role="tab" data-toggle="tab">新增註記</a></li>
                  <li role="presentation"><a href="#new_file" aria-controls="new_file" role="tab" data-toggle="tab">上傳檔案</a></li>
                </ul>
                <div class="widget-wrap" style="border-radius:0px 3px 3px 3px">
                  <div class="widget-content">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="tab-content">
                          <div role="tabpanel" class="tab-pane active" id="new_note">
                            <div class="form-content">
                              <div class="unit">
                                <div class="input">
                                  <label for="textarea">
                                  </label>
                                  <textarea v-autosize="temp_activity.content" rows="3" class="bootstrap_textarea" placeholder="新增註記內容" v-model="temp_activity.content"></textarea>
                                  <br>
                                </div>
                              </div>
                            </div>
                            <div class="form-footer j-forms">
                              <button class="btn btn-info primary-btn" @click="add_activity">新增</button>
                            </div>                          
                          </div>
                          <div role="tabpanel" class="tab-pane" id="new_file">
                            <dropzone 
                              id="myVueDropzone" 
                              :url="axios.defaults.baseURL + '/activities'" 
                              v-on:vdropzone-success="file_uploaded"
                              :headers=auth_token
                              :maxFileSizeInMB='12'
                              >
                              <!-- Optional parameters if any! -->
                              <input type="hidden" name="deal_token" v-bind:value="this.$route.params.deal_token">
                              <input type="hidden" name="activity[contact_id]" v-bind:value="contact.id">
                              <input type="hidden" name="activity[user_id]" v-bind:value="user_id">
                              <input type="hidden" name="activity[content_type]" value="attachment">
                            </dropzone>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <history :activities="contact_activities" :activity_categories="activity_categories"></history>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Page Container End Here-->
    <!-- modal template start-->
    <div v-if="OrganizationModal" @keyup.esc="OrganizationModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="OrganizationModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                新增公司
              </div>
              <a class="btn-close" @click="OrganizationModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms noscroll">
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-building"></i></label>
                  <autocomplete :url="axios.defaults.baseURL + '/settings/auto_complete'" anchor="name" label="contact_name" param="keyword" name="autocomplete" placeholder="公司名稱*" v-model="new_organization_value" :classes="{ input: 'form-control  new_organization_value', wrapper: 'input-wrapper'}" :process="process_organization_JSON" :onSelect="handle_organization_Select" :onInput="set_organization_Value" :customHeaders=auth_token :customParams="{ type: 'organization' }">
                  </autocomplete>
                </div>
              </div>
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-location-arrow"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="公司地址" v-model="address">
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="UpdateOrganization">
                  建立
                </button>
                <button class="btn btn-primary" @click="OrganizationModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="changeOrganizationModal" @keyup.esc="changeOrganizationModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="changeOrganizationModal=false">
          <div class="modal-container col-md-8" @click.stop>
            <div class="modal-header">
              <div name="header">
                變更客戶公司
              </div>
              <a class="btn-close" @click="changeOrganizationModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body  noscroll">
              <div class="row j-forms">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-user"></i></label>
                      <autocomplete :url="axios.defaults.baseURL + '/settings/auto_complete'" anchor="name" label="contact_name" param="keyword" name="autocomplete" placeholder="客戶公司*" v-model="new_organization_value" :classes="{ input: 'form-control  new_organization_value', wrapper: 'input-wrapper'}" :process="process_organization_JSON" :onSelect="handle_organization_Select" :onInput="set_organization_Value" :customHeaders=auth_token :customParams="{ type: 'organization' }">
                      </autocomplete>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms col-md-12">
              <div name="footer">
                <button class="btn btn-primary" @click="UpdateOrganization">
                  變更
                </button>
                <button class="btn btn-primary" @click="changeOrganizationModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <DeleteModal v-model="showDeleteModal" :AuthToken="auth_token" :TargetToken="this.$route.params.contact_token" :target="'contacts'"></DeleteModal>
  </div>
</template>
<script>
import autocomplete from 'vue2-autocomplete-js'
import moment from 'moment';
import history from '../Common/History';
import activitiesResource from '../Common/ActivitiesResource';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import Dropzone from 'vue2-dropzone'
import DeleteModal from '@/components/Common/DeleteModal';

export default {
  name: 'contact',
  components: {
    DeleteModal,
    Dropzone,
    autocomplete,
    history,
    activitiesResource
  },
  data() {
    return {
    	editColumnName: '',
    	editColumnId: '',
      contact: '',
      content_cache: '',
      contact_activities: [],
      note: '',
      activity_title: '',
      activity_content: '',
      activity_status: '',
      activity_priority: '',
      activity_date: '',
      activity_time: '',
      content_type: '',
      recent_deals: [],
      OrganizationModal: false,
      changeOrganizationModal: false,
      address: '',
      auth_token: {},
      quotations: [],
      new_organization_value: '',
      showDeleteModal: false,
      activity_categories:[],
      user_id: '',
      temp_activity: {},
    }
  },
  created() {
    this.getContact(this.$route.params.contact_token)
  },
  props: ['toggle_aside'],
  methods: {
  	editColumn(name,id){
      let vm = this
      this.editColumnName = name
      this.editColumnId = id
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[name+id])){
          vm.$refs[name+id][0].focus()
        }else{
          vm.$refs[name+id].focus()
        }
      })
    },
  	canEditColumn(colmn_name,id){
      let vm = this
      if(vm.editColumnName == colmn_name && vm.editColumnId == id){
        return true
      }else{
        return false
      }
    },
    finishedEditColumn(){
      this.editColumnName = ""
      this.editColumnId = ""
    },
    getContact(contact_token) {
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('contacts/show', {
          params: {
            'contact': { 'contact_token': contact_token },
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.contact = response['data']['data']['contact']
            vm.contact_activities = response['data']['data']['contact_activities']
            vm.recent_deals = response['data']['data']['recent_deals']
            vm.quotations = response['data']['data']['quotations']
            vm.user_id = response['data']['data']['user_id']
            vm.activity_categories = response['data']['data']['activity_categories']
            vm.tempActivityReset()
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    updateContact(contact) {
      const vm = this;
      this.finishedEditColumn()
      this.axios.put('contacts/'+contact.contact_token, {
          contact: {
            name: vm.contact.name,
            email: vm.contact.email,
            phone: vm.contact.phone,
            contact_token: vm.contact.contact_token,
          }
        })
        .then(function(response) {
          if (response.status == 200) {
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    ShowOrganization(organization_token) {
      this.$router.push({ name: 'organization', params: { organization_token: organization_token } })
    },
    ShowDeal(deal_token) {
      this.$router.push({ name: 'deal', params: { deal_token: deal_token } })
    },
    moment() {
      return moment();
    },
    tempActivityReset(){
      console.log('reset')
      this.temp_activity={
        id: '',
        title: '',
        content: '',
        start_date: new Date(),
        start_time: {'HH':(new Date()).getHours(),'mm':'00'},
        start:'',
        end_date: new Date(),
        end_time: {'HH':(new Date()).getHours(),'mm':'30'},
        end:'',
        allDay: true,
        location: '',
        user_id: this.user_id,
        deal_id: '',
        content_type: 'note',
        contact_id: this.contact.id,
        activity_status: 0,
        activity_priority: 0,
        activity_category_id: null,
        time_warning: false,
        activity_status: 'doing',
      }
    },
    add_activity() {
      const vm = this;
      // var check_time = this.syncTempStartEndDate() 
      // this.showNoteModal = false
      // this.showActivityModal = false
      // this.showUploadModal = false
      // if(check_time == false){
      //   return
      // }
      if(vm.temp_activity.content != '') {
        this.axios.post('activities', {
            activity: vm.temp_activity
          })
          .then(function(response) {
            if (response.status == 200) {
              // clear input value
              vm.tempActivityReset()
              vm.contact_activities.unshift(response['data']['data']['activity'])
            } else {
              console.log(response)
            }
          })
          .catch(function(error) {
            console.log('error:', error)
          });
      }
    },
    updateActivity(activity) {
      const vm = this;
      this.axios.put('activities/update_activity', {
        activity_id: activity.activity_id,
        content: activity.content
      })
      .then(function(response) {
        if (response.status == 200) {} else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    deleteActivity(activity) {
      // delete in html
      var index = this.contact_activities.indexOf(activity)
      this.contact_activities.splice(parseInt(index), 1)
      const vm = this;
      this.axios.delete('activities/delete_activity', {
        params: {
          activity_id: activity.activity_id
        }
      })
      .then(function(response) {
        if (response.status == 200) {} else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    UpdateOrganization() {
      const vm = this;
      this.axios.post('contacts/update_organization', {
        contact: {
          new_organization_value: this.new_organization_value,
          address: this.address,
          contact_token: this.$route.params.contact_token,
        }
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.contact.organization_token = response['data']['data']['organization_token']
          vm.contact.organization_name = vm.new_organization_value
          vm.OrganizationModal = false
          vm.changeOrganizationModal = false
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    file_uploaded(file, response){
      this.contact_activities.unshift(response['data']['activity'])
    },
    goAddQuotation(){
      this.$router.push({ name: 'new_quotation', params: { type: 'contact', token:  this.$route.params.contact_token} })
    },
    ShowQuotation(quotation_token) {
      this.$router.push({ name: 'show_quotation', params: { quotation_token: quotation_token } })
    },
    // AutoComplete callback function (Contact)
    process_organization_JSON(json) {
      return json.results.organization;
    },
    handle_organization_Select(data) {
      this.new_organization_value = data.name
    },
    set_organization_Value(value) {
      this.new_organization_value = value
    },
  },
  filters: {
    moment: function(date) {
      moment.locale('zh-tw');
      return moment(date).format('LLL');;
    }
  }
}
</script>


// WEBPACK FOOTER //
// Contact.vue?13c1800f